import chevronDown from '@iconify/icons-carbon/chevron-down';
import chevronUp from '@iconify/icons-carbon/chevron-up';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box } from '@mui/material';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { type FC, useCallback, useEffect, useMemo, useState } from 'react';

import { ActiveRouteController, Iconify } from '@larvitu/shared/mui/ui-components';
import { Link } from '@larvitu/shared/next/mui';

import { RootLinkStyle, RoutedHoverPopper } from './NavDesktop';
import NavDesktopMenu from './NavDesktopMenu';

import type { NavItemDesktopProps } from './types';

export const NavItemDesktop: FC<NavItemDesktopProps> = ({
  item,
  isScrolling = false,
  isTransparent = false,
}) => {
  const router = useRouter();
  const { t } = useTranslation();

  const [open, setOpen] = useState( false );

  const handleClose = useCallback( (): void => {
    setOpen( false );
  }, [] );

  useEffect( () => {
    if (open) {
      handleClose();
    }
  }, [open, router.pathname, handleClose] );

  if (item.children) {
    return (
      <RoutedHoverPopper
        placement="bottom"
        component={(props) => (
          <ActiveRouteController path={item.path}>
            <RootLinkStyle
              href={item.path}
              open={open}
              scrolling={isScrolling}
              transparent={isTransparent}
            >
              {/*{i18n?.t(item.title, { ns: 'common', defaultValue: '' } )}*/}
              {t( item.title, { ns: 'common', defaultValue: '' } )}
              <Box
                component="span"
                position="absolute"
              >
                {props.open ?? false
                  ? (
                    <KeyboardArrowUpIcon
                      width={16}
                      height={16}
                    />
                  )
                  : (
                    <KeyboardArrowDownIcon
                      width={16}
                      height={16}
                    />
                  )}
              </Box>
              {/*<Iconify*/}
              {/*  icon={props.open ?? false ? chevronUp : chevronDown}*/}
              {/*  sx={{*/}
              {/*    ml: 0.5,*/}
              {/*    width: 16,*/}
              {/*    height: 16,*/}
              {/*  }}*/}
              {/*/>*/}
            </RootLinkStyle>
          </ActiveRouteController>
        )}
      >
        <NavDesktopMenu
          lists={item.children}
          // isOpen
          isScrolling={isScrolling}
        />
      </RoutedHoverPopper>
    );
  }

  return (
    <ActiveRouteController path={item.path}>
      <RootLinkStyle
        href={item.path}
        open={open}
        scrolling={isScrolling}
        transparent={isTransparent}
      >
        {/*{i18n?.t(item.title, { ns: 'common', defaultValue: '' })}*/}
        {t( item.title, { ns: 'common', defaultValue: '' } )}
      </RootLinkStyle>
    </ActiveRouteController>
  );
};
